import { render, staticRenderFns } from "./providerMarkup.vue?vue&type=template&id=b9d1c450&scoped=true&"
import script from "./providerMarkup.vue?vue&type=script&lang=ts&"
export * from "./providerMarkup.vue?vue&type=script&lang=ts&"
import style1 from "./providerMarkup.vue?vue&type=style&index=1&id=b9d1c450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d1c450",
  null
  
)

export default component.exports